import { createApp } from 'vue'
import App from './App.vue'
import router from "@/router/router";
let app = createApp(App);
import axios from 'axios'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import '@/util/human.css'
import i18n from "@/i18n";


// axios.defaults.baseURL = "http://localhost:8050";
axios.defaults.baseURL = "";

app.use(router).use(Antd).use(i18n);
router.isReady().then(() => app.mount('#app'))
